<template>
<div>
    <nav class="navbar navbar-default navbar-fixed-top">
        <div class="nav-bg">
            <div class="nav_bar" @click="flag=flag==false?true:false">
              <span></span>
              <span></span>
              <span></span>
            </div>
        </div>
        <div class="container">
            <div id="navbar" class="text-center">
                <ul class="nav navbar-nav navbar-left nav-menu-search">
                    <li class="warp-search-header">
                        <i class="glyphicon glyphicon-search ico-search" aria-hidden="true" @click="menuChange"></i>
                        <div class="expand-nav-content-search"><input type="text" class="input-search-header" placeholder="Search" /></div>
                    </li>
                </ul>
                <ul class="nav navbar-nav navbar-right nav-menu-user">
                    <li class="warp-userinfo-header" >
                        <span class="iconfont icon-user ico-user" @click="menuChange"></span>
                        <div class="expand-nav-content-userinfo">
                            <span>{{userName}} &nbsp;|&nbsp; <a @click="logout">Logout</a></span></div>
                    </li>
                </ul>
            </div>
            <img v-if="$isAis" src="../assets/img/header/img_logo_ais_fibre.png" title="logo" class="logo-ais" />
            <img v-else src="../assets/img/header/logo.png" title="logo" class="logo-ais" />
        </div>
        <div class="toggle" v-show="userFlag">
            <div class="user">
                <span>{{userName}} &nbsp;|&nbsp; <a @click="logout">Logout</a></span>
            </div>
        </div>
        <div class="toggleS" v-show="searchFlag">
            <div class="search"  >
               <input type="text" placeholder="Search">
            </div>
        </div>
    </nav>
    
        <mobileNev v-bind:visible="flag" @changeNev="changeNev"  @close="close" ref="mobile"></mobileNev>
    </div>
</template>

<script>
import mobileNev from './mobileNav'
import _logout from '@/util/logout'
export default {
  components:{mobileNev},
  data() {
    return {
      flag:false,
      userFlag: false,
      searchFlag: false,
      userName: cookie.getItem("username") || "admin"
    };
  },
  methods: {
    close(flag){
      this.flag=flag;
    },
    logout() {
      _logout()
    },
    menuChange(e) {
      if (window.screen.width <= 768) {
        if (e.target.nodeName == "I") {
          if (this.searchFlag == false) {
            this.userFlag = false;
            this.searchFlag = true;
          } else {
            this.userFlag = false;
            this.searchFlag = false;
          }
        } else {
          if (this.userFlag == false) {
            this.userFlag = true;
            this.searchFlag = false;
          } else {
            this.userFlag = false;
            this.searchFlag = false;
          }
        }
      }
    },
    changeNev(index,index1){
      this.$emit("changeNev",index,index1);
    }
  }
};
</script>

<style src="@/assets/style/bootstrap.css"></style>


<style src="@/assets/style/header.scss" lang="scss"></style>